import { PlanType } from "../../components/enums/plan-type";

export default function enrollmentsReducer(state = [], action) {

    switch (action.type) {
        case "UPDATE_ENROLLMENTS":
            return action.enrollments;
        case "UPDATE_STEP":
                return {...state, currentStep: action.step};
        case "UPDATE_EMPLOYEE":
            return {...state, employee: action.employee};
        case "UPDATE_DEPENDENT":
            let contacts = state.contacts?.filter((d) => d.id !== action.contact.id);
            contacts.push(action.contact);
            contacts.sort((a, b) => {
                return new Date(a.birthdate) - new Date(b.birthdate);
            });
            let dependents = state.dependents;
            if(state.dependents.indexOf(action.contact.id) === -1)
                dependents = dependents.concat([action.contact.id]);

            return {...state, contacts: contacts, dependents: dependents};
        case "UPDATE_CONTACT":
            let c = state.contacts?.filter((d) => d.id !== action.contact.id);
            c.push(action.contact);
            c.sort((a, b) => {
                return new Date(a.birthdate) - new Date(b.birthdate);
            });
            return {...state, contacts: c};
        case "UPDATE_CONTACTS":
            const contactIds = action.contacts.map(s => s.id);
            let filtered = state.contacts?.filter((d) => !contactIds.includes(d.id));
            action.contacts.forEach(s => {
                filtered.push(s);
            });
            filtered.sort((a, b) => {
                return new Date(a.birthdate) - new Date(b.birthdate);
            });
            return {...state, contacts: filtered};
        case "DELETE_DEPENDENT":
            return {...state, dependents: state.dependents?.filter((d) => d !== action.dependentId)};
        case "ADD_ATTACHMENT":
            var attachments = state.attachments ? state.attachments.concat([action.attachment]) : [action.attachment];
            return {...state, attachments: attachments};
        case "REMOVE_ATTACHMENT":
            return {...state, attachments: state.attachments?.filter((d) => d.enrollmentAttachmentTypeId !== action.category)};
        case "UPDATE_SELECTION":
            let selections = state.selections.filter((s) => s.planType !== action.selection.planType);
            selections = selections.concat(action.selection);
            return {...state, selections: selections};
        case "UPDATE_INSURANCE":
            let insurance = state.selections.filter((s) => s.planType !== PlanType.VoluntaryLife && s.planType !== PlanType.SpouseLife && s.planType !== PlanType.ChildLife && s.planType !== PlanType.BasicLife && s.planType !== PlanType.BeneficiaryLife );
            action.selections.forEach(selection => {
                insurance.push(selection);
            });
            return {...state, selections: insurance};
        case "UPDATE_FSA":
            let fsa = state.selections.filter((s) => s.planType !== PlanType.MedicalCareFsa  && s.planType !== PlanType.DependentCareFsa);
            action.selections.forEach(selection => {
                fsa.push(selection);
            });
            return {...state, selections: fsa};
        case "UPDATE_ENROLLMENTSTYPE":
            return {...state, 
                effectiveDate: action.enrollmentsType.effectiveDate,
                enrollmentTypeId: action.enrollmentsType.enrollmentTypeId,
                lifeEventId: action.enrollmentsType.lifeEventId,
                lifeEventDescription: action.enrollmentsType.lifeEventDescription,
            };
        default:
            return state;
    }
}
